<template>
    <div>
        <portal to="title">
            {{title}}
        </portal>
        <displayScreen v-if="numberOfScreens > 1" :screenHeight="screen1Height">
            <slideshow-component
                v-if="showSlider"
                :items="items"
                :music="music"
                :autoplayTimeout="autoplayTimeout"
                :maxHeight="screen1Height"
            />
        </displayScreen>
        <displayScreen :screenHeight="numberOfScreens > 1 ? screen2Height : null">
            <terminalLayout :showWithdrawalButton="showWithdrawalButton" @openWithdrawalModal="openWithdrawalModal()" />
            <games
                :games="games"
                :gameVolume="gameVolume"
                :lobbyRows="rows"
                :lobbyColumns="columns"
                :maxHeight="numberOfScreens > 1 ? maxGameContainerHeight : null"
            />
        </displayScreen>
        <withdrawal v-if="isWithdrawalModalOpen" ref="withdrawalModal" @close="closeWithdrawalModal()">
        </withdrawal>
    </div>
</template>

<script>
import Withdrawal from "../Components/Withdrawal";
import Games from "../Components/Games";
import SlideshowComponent from "../Components/SlideshowComponent";
import DisplayScreen from "../Components/DisplayScreen";
import TerminalLayout from "../Layout";
import CalculateScreens from "../../Shared/mixin/CalculateScreens";
export default {
    name: 'Lobby',
    mixins: [
        CalculateScreens,
    ],
    props: {
        games: Array,
        openWithdrawal: Boolean,
        rows: Number,
        columns: Number,
        slideshowDelay: Number,
        gameVolume: Number,
        showWithdrawalButton: Boolean,
    },
    components: {TerminalLayout, DisplayScreen, SlideshowComponent, Withdrawal, Games },
    metaInfo() {
        return {
            title: this.title,
        }
    },
    computed: {
        title () {
            return this.$t('Lobby');
        }
    },
    data() {
        return {
            balance: this.$page.props.balance,
            isWithdrawalModalOpen: false,
            processing: false,
            polling: null,
            items: [],
            music: null,
            autoplayTimeout: 0,
            showSlider: false,
        }
    },
    created() {
        window.addEventListener('keydown', this.listenOnLobby);
        Echo
            .private(`player-${this.$page.props.user.id}`)
            .listen('BalanceChanged', (e) => {
                this.balance = e.balance;
                if (this.balance > 0) {
                    clearTimeout(this.polling);
                }
            });

        this.startSlideshowTimeout();

        if(this.openWithdrawal) {
            this.openWithdrawalModal();
        }
    },
    mounted() {
        this.startSlideshow();
        this.calculateScreenHeight();
        window.addEventListener('resize', this.calculateScreenHeight);
    },
    methods: {
        listenOnLobby(e) {
            switch (e.key) {
                case 'c':
                    e.preventDefault();
                    this.openWithdrawalModal();
                    break;
                default:
                    this.startSlideshowTimeout();
            }
        },
        openWithdrawalModal() {
            this.isWithdrawalModalOpen = true;
            window.removeEventListener('keydown', this.listenOnLobby);
            clearTimeout(this.polling);
        },
        closeWithdrawalModal() {
            this.isWithdrawalModalOpen = false;
            window.addEventListener('keydown', this.listenOnLobby);
            this.startSlideshowTimeout();
        },
        async startSlideshowTimeout() {
            const response = await axios.get(this.route('terminal.balance'));
            if (response) {
                this.balance = response.data.balance;
            }
            if(this.slideshowDelay && this.balance <= 0 && this.numberOfScreens <= 1) {
                clearTimeout(this.polling);
                this.polling = setTimeout(() => {
                    this.$inertia.visit(this.route('terminal.slideshow'));
                }, this.slideshowDelay*1000)
            }
        },
        onClose() {
            this.startSlideshowTimeout();
        },
        async startSlideshow() {
            const response = await axios.get(this.route('terminal.slideshow-data'));
            if (response) {
                this.items = response.data.items;
                this.music = response.data.music;
                this.autoplayTimeout = response.data.autoplayTimeout;
                this.showSlider = true;
            }
        },
    },
    beforeDestroy() {
        window.removeEventListener('keydown', this.listenOnLobby);
    }
}
</script>
